module.exports = __webpack_public_path__ + "img/CU-Phosco-Lighting.3a4d365b.jpg";